import { tutorialAssets } from "assets/cdn";
import { useImagePath } from "hooks/useImagePath";
import { Grid, useMediaQuery } from "@mui/material";
import { GenericPointBalance } from "components/AppNavigation/AppBar/lib/AppBarUser/lib";
import Button from "components/Buttons/ThemeButton";
import useCalculateScale from "components/PopUpManager/hooks/useCalculateScale";
import { debounce } from "lodash";
import { useEffect, useRef, useState } from "react";
import { CrownIconV2 } from "utils/svgIcons";
import { Arrow, Background2, Shine, Text, Tiki2 } from "../../styles";
import {
	ArrowContainer,
	Container,
	ContainerPointBalance,
	SlideNumberContainer
} from "./style";

interface Slide4Props {
	points: number;
	onNext: () => void;
	onSkip: () => void;
	number: number;
	slideNumber: number;
}

export const Slide4 = ({
	points,
	onNext,
	onSkip,
	number,
	slideNumber
}: Slide4Props) => {
	const { getImage } = useImagePath("cdn");
	const background = getImage(tutorialAssets.background);
	const arrowUp = getImage(tutorialAssets.greenArrow);
	const shineAsset = getImage(tutorialAssets.shine);
	const tiki = getImage(tutorialAssets.char2);
	const containerRef = useRef<HTMLDivElement>(null);
	const isPortrait = useMediaQuery("(orientation: portrait)");
	const [lpBalancePosition, setLpBalancePosition] = useState<DOMRect | null>(
		null
	);
	const [tutorialPosition, setTutorialPosition] = useState<{
		top: number;
		left: number;
	}>({ top: 0, left: 0 });

	const scale = useCalculateScale(
		isPortrait ? 400 : 500,
		isPortrait ? 200 : 400
	);

	const handleResize = () => {
		const element = document.getElementById("loyalty-point-balance");
		const rect = element?.getBoundingClientRect();
		setLpBalancePosition(rect || null);
	};

	useEffect(() => {
		if (containerRef?.current && lpBalancePosition) {
			const rect = containerRef.current.getBoundingClientRect();
			const scalePercentageLeft = 1 - scale;
			setTutorialPosition({
				top: lpBalancePosition.top + lpBalancePosition.height + 5,
				left:
					lpBalancePosition.left +
					lpBalancePosition.width / 2 -
					rect.width * 0.69 +
					46 * scalePercentageLeft
			});
		}
	}, [
		containerRef?.current,
		lpBalancePosition,
		scale,
		window.innerWidth,
		window.innerHeight
	]);

	useEffect(() => {
		handleResize();
	}, []);

	const debounceResize = debounce(handleResize, 200);

	useEffect(() => {
		window.addEventListener("resize", debounceResize);
		window.addEventListener("transitionend", debounceResize);

		return () => {
			window.removeEventListener("resize", debounceResize);
			window.removeEventListener("transitionend", debounceResize);
		};
	}, []);

	return (
		<>
			{lpBalancePosition && (
				<>
					<ContainerPointBalance
						top={lpBalancePosition.top}
						left={lpBalancePosition.left}
						style={{
							width: lpBalancePosition.width,
							height: lpBalancePosition.height
						}}
					>
						<GenericPointBalance>
							<CrownIconV2 />
							{points.toLocaleString("en-US")}
						</GenericPointBalance>
					</ContainerPointBalance>
					<Shine
						src={shineAsset}
						width={130}
						height={130}
						className="animate"
						position="fixed"
						top={`${lpBalancePosition.top + lpBalancePosition.height / 2}px`}
						left={`${lpBalancePosition.left + lpBalancePosition.width / 2}px`}
					/>
					<Container
						ref={containerRef}
						scale={scale}
						top={tutorialPosition.top}
						left={tutorialPosition.left}
					>
						<ArrowContainer scale={scale}>
							<Arrow src={arrowUp} alt="Arrow up" width={46} />
						</ArrowContainer>
						<div>
							<SlideNumberContainer>
								<Text
									color="#fff"
									fontFamily="Baloo"
									fontSize="16px"
									lineHeight="17px"
								>
									{number}/{slideNumber}
								</Text>
							</SlideNumberContainer>

							<Grid item width={331}>
								<Background2 $backgroundImage={background}>
									<div>
										<Tiki2 src={tiki} alt="Tiki" bottom="10px" />
									</div>
									<div>
										<Text
											color="#462C12"
											fontFamily="Inter"
											fontSize="16px"
											fontWeight={700}
											lineHeight="17px"
										>
											Here&apos;s your Loyalty
											<br /> Points balance, you can
											<br /> check it anytime!
										</Text>
									</div>
									<Button className="next" onClick={onNext}>
										Next
									</Button>
									<Button className="skip" variant="text" onClick={onSkip}>
										Skip
									</Button>
								</Background2>
							</Grid>
						</div>
					</Container>
				</>
			)}
		</>
	);
};
